export enum EnvEnum {
    CONTRACTS_URL = 'API.CONTRACTS_URL',
    DASHBOARD_URL = 'API.DASHBOARD.DASHBOARD_URL',
    HOMELAN_URL = 'API.DASHBOARD.HOMELAN_URL',
    HOMELAN_ECO_MODE_URL = 'API.DASHBOARD.HOMELAN_ECO_MODE_URL',
    TESTER_DEPANNER_BASE_URL = 'API.DASHBOARD.TESTER_DEPANNER_BASE_URL',
}
